<script setup lang="ts">
import {useCreditStore} from "@/stores/credit.store";
import {CommunicationMode} from "@/communication/types";
import {MessageSquare, BellRing} from "@lucide/vue";

const {credit} = useCreditStore();
const props = defineProps<{
    loading: boolean;
}>();

const mode = defineModel<"sms" | "notification">("mode");

/**
 * Toggle the mode.
 *
 * @param to
 */
const toggleMode = (to: CommunicationMode) => {
    if (!props.loading) {
        mode.value = to;
    }
};

</script>

<template>
  <div class="flex border shadow-sm rounded-full bg-white p-0.5 gap-2">
    <div
      class="flex rounded-full items-center gap-2 py-2 px-4 font-medium text-muted-foreground cursor-pointer hover:text-black transition-colors duration-100"
      :class="{
        'text-white bg-primary font-medium' : mode === 'sms'
      }"
      @click="toggleMode('sms')"
    >
      <MessageSquare class="size-5" />
      <span>
        Mode SMS <span
          v-if="credit?.balance !== undefined" class="text-sm leading-tight font-medium"
        >
          - {{ credit.balance }} {{ $filters.pluralize('crédit', credit.balance) }}
        </span>
      </span>
    </div>
    <div
      class="flex rounded-full items-center gap-2 py-2 px-4 font-medium text-muted-foreground cursor-pointer hover:text-black transition-colors duration-100"
      :class="{
        'text-white bg-primary font-medium' : mode === 'notification'
      }"
      @click="toggleMode('notification')"
    >
      <BellRing class="size-5" />
      <span>
        Mode Notification <span
          class="text-sm leading-tight font-medium"
        >
          - Gratuit !
        </span>
      </span>
    </div>
  </div>
</template>
